const About = () => {
    return (<div className="row  box border">
        <div className="col-lg-7 col-md-7 col-sm-6 col-xs-12">
            <h1>About Us</h1>
            Delfin Technologies provides remote Software design and development.  <br />
            <i>Front-end and Full stack (React, Angular, .Net)</i> <br/><br/>
            Learn more by browsing our track record: <a href="/engagements">20+ years of successful engagements!</a>
        </div>
        
    </div>)
}
export default About;